import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=dcfa1856&scoped=true"
import script from "./jobDetails.vue?vue&type=script&lang=js"
export * from "./jobDetails.vue?vue&type=script&lang=js"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=dcfa1856&prod&lang=css"
import style1 from "./jobDetails.vue?vue&type=style&index=1&id=dcfa1856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa1856",
  null
  
)

export default component.exports